function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.313 11.11h-2.865a7.502 7.502 0 00-6.557-6.558V1.688a.188.188 0 00-.188-.188h-1.406a.188.188 0 00-.188.188v2.864a7.502 7.502 0 00-6.557 6.557H1.688a.188.188 0 00-.188.188v1.406c0 .103.084.188.188.188h2.864a7.502 7.502 0 006.557 6.557v2.864c0 .104.085.188.188.188h1.406a.188.188 0 00.188-.188v-2.864a7.502 7.502 0 006.557-6.557h2.864a.188.188 0 00.188-.188v-1.406a.188.188 0 00-.188-.188zM12 17.718A5.717 5.717 0 016.281 12c0-3.16 2.56-5.719 5.719-5.719 3.16 0 5.719 2.56 5.719 5.719 0 3.16-2.56 5.719-5.719 5.719z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8c-1.07 0-2.07.413-2.827 1.173A3.966 3.966 0 008 12c0 1.07.417 2.07 1.173 2.827A3.986 3.986 0 0012 16c1.067 0 2.07-.417 2.827-1.173A3.986 3.986 0 0016 12c0-1.067-.417-2.07-1.173-2.827A3.952 3.952 0 0012 8z",
    fill: props.fill
  }));
}

export default SvgAim;